import { gql } from 'graphql-tag';

export const GET_MAINTENANCE_PARTS_BY_PART = gql`
  query GetMaintenancePartsByPart($partId: ID!) {
    maintenancePartsByPart(partId: $partId) {
      id
      accountId
      maintenanceId
      partId
      quantity
      createdAt
      updatedAt
      deletedAt
      maintenance {
        id
        title
        assetId
        type
      }
      asset {
        id
        name
      }
    }
  }
`;
